import asyncActionTypes from '../actions/types.js';
import FulfillRefundUIModel from '../../api-wrapper/ui-models/refund/fullRefundModels/fulfillRefund.js';

const initialState = {
  errorFulfillRefund: false,
  fulfillRefundData: null,
  loadingFulfillRefund: false,
};

const fulfillRefund = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_FULFILL_REFUND.START:
      return {
        ...state,
        errorFulfillRefund: false,
        loadingFulfillRefund: true,
      };
    case asyncActionTypes.RETRIEVE_FULFILL_REFUND.SUCCESS:
      const fulfillData = new FulfillRefundUIModel(action.payload);
      return {
        ...state,
        errorFulfillRefund: false,
        fulfillRefundData: fulfillData,
        loadingFulfillRefund: false,
      };
    case asyncActionTypes.RETRIEVE_FULFILL_REFUND.FAIL:
      return {
        ...state,
        errorFulfillRefund: true,
        loadingFulfillRefund: false,
      };
    default:
      return state;
  }
};

export default fulfillRefund;